import { Injectable } from "@angular/core";

import
{
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";

import { catchError, map, of, switchMap } from "rxjs";
import { PermissionsService } from "../../shared/services/permission.service";
import { loadUserPermissions, loadUserPermissionsFailure, loadUserPermissionsSuccess } from "./permissions.actions";


@Injectable()
export class PermissionsEffects
{
 constructor(
    private actions$: Actions,
    private permissionsService: PermissionsService
  )
  {  }

  loadPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserPermissions),
      switchMap(() => 
        this.permissionsService.getUserPermissions().pipe(
          map((userPermissions) => loadUserPermissionsSuccess({ userPermissions })),
          catchError((error) => of(loadUserPermissionsFailure({ error })))
        )
      )
    )
  );
}